export default __webpack_public_path__ + "static/media/Header.ccc3f6a8.png";